import {createQueryKeys} from "../../shared/query/query-keys";

export const supplierKeys = createQueryKeys("suppliers");

export const supplierMutationKeys = {
  createSupplier: ["suppliers", "mutation", "create-supplier"] as const,
  updateSupplier: ["suppliers", "mutation", "update-supplier"] as const,
  deleteSupplier: ["suppliers", "mutation", "delete-supplier"] as const,
  restoreSupplier: ["suppliers", "mutation", "restore-supplier"] as const,
  addSupplierFunction: ["suppliers", "mutation", "add-supplier-function"] as const,
  removeSupplierFunction: ["suppliers", "mutation", "remove-supplier-function"] as const,
  addSupplierContact: ["suppliers", "mutation", "add-supplier-contact"] as const,
  editSupplierContact: ["suppliers", "mutation", "edit-supplier-contact"] as const,
  removeSupplierContact: ["suppliers", "mutation", "remove-supplier-contact"] as const,
  addSupplierNote: ["suppliers", "mutation", "add-supplier-note"] as const,
  editSupplierNote: ["suppliers", "mutation", "edit-supplier-note"] as const,
  removeSupplierNote: ["suppliers", "mutation", "remove-supplier-note"] as const,
} as const;
